import React, {useRef, useState} from 'react';

import axiosInstance from "../../api/axios";
import './style.css';
import {Button, CircularProgress, Grid, InputLabel, TextField} from '@material-ui/core'
import ReCAPTCHA from "react-google-recaptcha";
import env from "../../env/env";
import {showWarningNotify} from "../../components";
import withStyles from '@material-ui/core/styles/withStyles';
import {compose} from "redux";

const styles = {
    marTop16: {
        marginTop: 16
    },
    marBot16: {
        marginBottom: 16
    },
    marLeft16: {
        marginLeft: 16
    },
    marLeftRight16: {
        marginLeft: 16,
        marginRight: 16
    },
    qrImage: {
        height: 150,
        width: 150
    },
    flexRowBetween: {
        justifyContent: 'space-between',
        display: 'flex',
        width: '100%'
    },
    width100: {
        width: '100%'
    },
    font16: {
        fontSize: 18
    },
    textBold: {
        fontWeight: 'bold'
    },
    textCenter: {
        textAlign: 'center'
    },
    bigHeader2: {
        fontSize: 20,
        fontWeight: 'bold'
    }
};

const TraCuuTuyenSinhV2 = ({selectedTenant = {}}) => {
    const [loading, setLoading] = useState(false);
    const [clickCaptcha, setClickCaptcha] = useState(false);
    const [sbd, setSbd] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [dob, setDob] = useState('');
    const [displayData, setDisplayData] = useState(false);
    const [haveData, setHaveData] = useState(null);
    const [htmlResult, setHtmlResult] = useState(null);
    const captchaRef = useRef(null)
    const submitFindAdmission = (e) => {
        e.preventDefault();
        const token = captchaRef.current.getValue();
        if (!token) {
            showWarningNotify('Vui lòng nhập Captcha')
            return
        }
        if (!sbd) {
            if (!customerName || !dob) {
                showWarningNotify('Vui lòng (Họ Tên và Ngày sinh) hoặc Số báo danh để tra cứu thông tin tuyển sinh')
                return
            }
        }
        const data = {
            token,
            dob, sbd, customerName,
            tenantId: selectedTenant.id
        }
        captchaRef.current.reset();
        setLoading(true)
        setDisplayData(false)
        const url = `/public/checkAdmissions`;
        axiosInstance.post(url, data).then(rs => {
            setLoading(false)
            setClickCaptcha(false)
            const data = rs.data
            setDisplayData(true)
            if (data && data.success) {
                setHaveData(true)
                setHtmlResult(data.htmlContent)
            }
        })
    }

    function onChangeCaptcha(value) {
        if (value) {
            setClickCaptcha(true)
        } else {
            setClickCaptcha(false)
        }
    }

    const resetForm = () => {
        setDisplayData(false)
        setHtmlResult(null)
        setCustomerName('')
        setDob('')
        setSbd('')
    }

    return (
        <Grid container className={'main-info'}>
            <Grid container className={'main-data-info'}>
                <div style={{display: 'flex', flex: 1, justifyContent: 'center', margin: '16px'}}>
                    <img style={{width: 120, height: 120}}
                         src={`${env.baseURL}${selectedTenant.logo}`}/>
                </div>
                {displayData ?
                    <Grid container>
                        {htmlResult ?
                            <Grid container>
                                <Grid container style={styles.marLeftRight16}>
                                    <div id='resultContainer' dangerouslySetInnerHTML={{__html: htmlResult}}/>
                                    {/*<div style={{...styles.width100, ...styles.marTop16, ...styles.textCenter}}>*/}
                                    {/*    <span>{'Tải ứng dụng VinaID ngay '}</span>*/}
                                    {/*    <a href="https://bit.ly/VinaIDapp"><span>{'tại đây'}</span></a>*/}
                                    {/*</div>*/}
                                    {/*<div style={{...styles.width100, ...styles.textCenter}}>*/}
                                    {/*    <img style={styles.qrImage}*/}
                                    {/*         src={env.baseURL + '/files/qr_vinaid_app.png'}*/}
                                    {/*         alt=""></img>*/}
                                    {/*    /!*<img src={env.baseURL + '/files/qr_vinaid_app.png'} alt=""></img>*!/*/}
                                    {/*</div>*/}
                                    <Button style={{...styles.marTop16, ...styles.marBot16}} variant="outlined"
                                            color="primary"
                                            onClick={resetForm}>
                                        Quay lại
                                    </Button>
                                </Grid>
                            </Grid>
                            :
                            <>
                                <div
                                    style={{...styles.width100, ...styles.bigHeader2, ...styles.marTop16,}}>{'Không tìm thấy thông tin học sinh trong danh sách xác nhận nhập học. Vui lòng kiểm tra lại thông tin'}</div>
                                <Button style={{...styles.marTop16, ...styles.marBot16}} variant="outlined"
                                        color="primary"
                                        onClick={resetForm}>
                                    Quay lại
                                </Button>
                            </>
                        }
                    </Grid>
                    :
                    <Grid container style={styles.marLeftRight16}>
                        <div className={"big-header"}>ĐĂNG KÝ NHẬP HỌC</div>
                        <div className={"big-header"}>năm học 2026-2027</div>
                        <div className={"text-center"}>{`Trường học: ${selectedTenant.name}`}</div>
                        <div
                            className={"big-header2"}>{'Nhập Số báo danh hoặc (Họ Tên và Ngày sinh) để đăng ký nhập học'}</div>
                        <Grid container style={{...styles.marTop16}}>
                            <Grid item xs={4}>
                                <InputLabel>{'Số báo danh (Ưu tiên 1):'}</InputLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField value={sbd} onChange={(e) => setSbd(e.target.value)}/>
                            </Grid>
                        </Grid>
                        <Grid container style={{...styles.marTop16}}>
                            <Grid item xs={4}>
                                <InputLabel>{'Họ Tên (Ưu tiên 2):'}</InputLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField value={customerName} onChange={(e) => setCustomerName(e.target.value)}/>
                            </Grid>
                        </Grid>
                        <Grid container style={{...styles.marTop16}}>
                            <Grid item xs={4}>
                                <InputLabel>{'Ngày sinh (Ưu tiên 2):'}</InputLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField value={dob} type="date" id="birthday" name="birthday"
                                           onChange={(e) => setDob(e.target.value)}/>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} style={styles.marTop16}>
                            <ReCAPTCHA
                                sitekey={env.captchaSiteKey}
                                onChange={onChangeCaptcha}
                                ref={captchaRef}
                            />
                        </Grid>
                        <Button style={{...styles.marTop16, ...styles.marBot16}} variant="outlined" color="primary"
                                onClick={submitFindAdmission}
                                disabled={!clickCaptcha || loading}>
                            Tra cứu
                        </Button>
                    </Grid>
                }
                {loading && <Grid item xs={12}><CircularProgress color="secondary"/> </Grid>}
                <div style={{margin: '0 16px', width: '100%'}}>

                    <div style={{border: '1px solid whitesmoke', width: '100%'}}/>
                    <div style={{marginTop: 8}}>
                        <p style={{fontStyle: 'italic', fontSize: 15, color: '#0000008a'}}>© 2026 - Trang thông tin được
                            xây
                            dựng và phát triển bởi {selectedTenant.name} và <a href='https://www.facebook.com/VinaID.vn' target='_blank'
                                                                               style={{color: 'blue'}}>VinaID</a>
                        </p>
                    </div>
                </div>
            </Grid>

        </Grid>
    )
}

export default compose(
    withStyles(styles)
)(TraCuuTuyenSinhV2);
